const itensLogProposals = {
  account_id: 'ID da conta',
  application_id: 'origem do aplicativo',
  bank_id: 'ID do banco',
  bank_proposal_identifier: 'ID da proposta do banco',
  cdc_proposal_id: 'ID do CDC da proposta',
  cet_annually: 'CET (anual)',
  cet_monthly: 'CET (mensal)',
  chassi_code: 'chassi',
  cnh_simulation_id: 'ID da CNH',
  coefficient: 'coeficiente',
  color: 'cor',
  commercial: 'uso do veículo',
  created_at: 'data de cadastro',
  creation_external_link_id: 'ID do link externo',
  external_simulation_uuid: 'UUID da simulação',
  financed_amount_cents: 'valor financiado',
  first_payment_in_days: 'tempo para o primeiro pagamento',
  fixed_installments: 'parcelas',
  fuel_id: 'ID do combustível',
  funding_type_id: 'ID do tipo de financiamento',
  has_accessory: 'tem accesório?',
  has_license_plate: 'tem placa?',
  honda_id: 'ID',
  honda_plan_id: 'plano',
  honda_status_id: 'ID do status',
  honda_table_id: 'ID da tabela',
  input_custom_vehicle_model_id: 'ID do modelo de veículo personalizado',
  input_financing_cents: 'valor da entrada',
  input_obs: 'observações',
  input_origin: 'origin',
  input_vehicle_year: 'ano do veículo',
  km_mileage: 'kilômetros',
  license_plate_code: 'placa',
  licensing_city: 'cidade de licenciamento',
  licensing_uf: 'estado de licenciamento',
  obs: 'as observações',
  owner_id: 'responsabilidade',
  outdated: 'desatualizado',
  payment_type_id: 'ID do tipo de Pagamento',
  plan: 'plano',
  plan_offset: 'compensação do plano',
  plus_percentage: 'percentagem plus',
  plus_value_cents: 'valor plus',
  primary_proposal_attemp_id: 'ID da tentativa da proposta principal',
  proposal_id: 'ID da proposta',
  quota_cents: 'valor da parcela',
  replaces_proposal_attemp_id: 'ID da tentativa da proposta',
  renavam_code: 'renavam',
  return_value_cents: 'valor do retorno',
  seller_id: 'ID do vendedor',
  simulation_condition_id: 'condição',
  state: 'status',
  table: 'tabela',
  term_financing: 'prazo do financiamento',
  type: 'tipo',
  updated_at: 'data de atualização',
  value_cents: 'valor do veículo',
  value_of_the_accessory_cents: 'valor de accesórios',
  value_of_the_license_plate_cents: 'valor da documentação',
  vehicle_model_id: 'veículo',
  webhook_url: 'URL de webhook',
  year_of_manufacture: 'ano de fabricação',
  year_of_model: 'ano do modelo',
  zero_km: 'estado do veículo',
};

const itensLogCustomers = {
  accept_boleto: 'aceita boleto',
  account_id: 'ID da conta',
  account_number: 'número da conta',
  address: 'endereço',
  address_type_id: 'ID do tipo de endereço',
  agency: 'agência',
  amount_of_branchs: 'quantidade de filiais',
  amount_of_dependent: 'quantidade de dependentes',
  amount_of_employees: 'quantidade de funcionários',
  another_income_cents: 'outra renda em centavos',
  another_income_origin: 'origem da outra renda',
  another_income_type_id: 'ID do tipo de outra renda',
  attachment_kind: 'tipo de anexo',
  attachment_type_id: 'ID do tipo de anexo',
  avatar: 'avatar',
  bank_id: 'ID do banco',
  belong_to_an_economic_group: 'pertence a um grupo econômico',
  billing_cents: 'cobrança em centavos',
  born_at: 'data de nascimento',
  branch: 'filial',
  build_type_id: 'ID do tipo de construção',
  city: 'cidade',
  cnh: 'CNH',
  cnh_type_id: 'ID do tipo de CNH',
  cnpj: 'CNPJ',
  code: 'código',
  company_activity_id: 'ID da atividade da empresa',
  complement: 'complemento',
  content_type: 'tipo de conteúdo',
  cpf: 'CPF',
  creation_external_link_id: 'ID do link externo de criação',
  credit_cards: 'cartões de crédito',
  customer_id: 'ID do cliente',
  customer_type: 'tipo de cliente',
  department: 'departamento',
  detail: 'detalhe',
  digit: 'dígito',
  document_type: 'tipo de documento',
  education_id: 'ID do nível de educação',
  father: 'nome do pai',
  file: 'arquivo',
  file_size: 'tamanho do arquivo',
  first_job: 'primeiro emprego',
  function: 'função',
  genre_id: 'ID do gênero',
  has_cnh: 'possui CNH',
  has_made_funding: 'fez financiamento',
  have_bank_account: 'possui conta bancária',
  have_credit_card: 'possui cartão de crédito',
  ie: 'IE',
  im: 'IM',
  income_cents: 'renda em centavos',
  joined_at: 'data de entrada',
  joint_stock_cents: 'capital social em centavos',
  main: 'principal',
  main_partner: 'sócio principal',
  marital_status_id: 'ID do estado civil',
  month: 'mês',
  mother: 'nome da mãe',
  name: 'nome',
  nationality: 'nacionalidade',
  neighborhood: 'bairro',
  nickname: 'apelido',
  note: 'nota',
  number: 'número',
  open_at: 'data de abertura',
  original_filename: 'nome original do arquivo',
  overdraft: 'limite de cheque especial',
  phone_confirmation_id: 'ID de confirmação de telefone',
  phone_type_id: 'ID do tipo de telefone',
  place_of_birth: 'local de nascimento',
  previous_funding_bank_id: 'ID do banco de financiamento anterior',
  previous_work: 'trabalho anterior',
  previous_work_end_at: 'data de término do trabalho anterior',
  previous_work_start_at: 'data de início do trabalho anterior',
  profession_id: 'ID da profissão',
  professional_ocupation_id: 'ID da ocupação profissional',
  property: 'propriedade',
  public_person: 'pessoa públicamente exposta',
  quota: 'cota',
  reference: 'referência',
  relationship: 'relacionamento',
  rent_value_cents: 'valor do aluguel em centavos',
  rg: 'RG',
  rg_date: 'data de emissão do RG',
  rg_issuing: 'órgão emissor do RG',
  rg_state_id: 'ID do estado do RG',
  rg_state_id_abbreviation: 'abreviação do estado do RG',
  role: 'função',
  set_time_month: 'mês de ajuste de horário',
  set_time_year: 'ano de ajuste de horário',
  spouse_born_at: 'data de nascimento do cônjuge',
  spouse_cpf: 'CPF do cônjuge',
  spouse_name: 'nome do cônjuge',
  spouse_rg: 'RG do cônjuge',
  spouse_rg_date: 'data de emissão do RG do cônjuge',
  spouse_rg_issuing: 'órgão emissor do RG do cônjuge',
  spouse_rg_state_id: 'ID do estado do RG do cônjuge',
  started_at: 'data de início',
  state: 'estado',
  state_id: 'ID do estado',
  state_of_birth_id: 'ID do estado de nascimento',
  street: 'rua',
  talk_to: 'falar com',
  user_id: 'ID do usuário',
  updated_at: 'data de atualização',
  year: 'ano',
  zip_code: 'CEP',
};

const itemType = {
  Customer: {
    name: 'nome do cliente',
    cnpj: 'CNPJ do cliente',
    cpf: 'CPF do cliente',
    customer_id: 'ID do cliente',
  },
  JobReference: {
    name: 'nome do emprego',
    cnpj: 'CNPJ do emprego',
    detail: 'benefício INSS',
  },
  Phone: {
    number: 'número de telefone',
  },
  Partner: {
    name: 'nome do sócio',
    cpf: 'CPF do sócio',
    cnpj: 'CNPJ do sócio',
    customer_id: 'ID do sócio',
  },
  Address: {
    number: 'número de endereço',
    city: 'cidade do endereço',
  },
  PersonalReference: {
    city: 'cidade da referência pessoal',
    customer_id: 'ID da referência pessoal',
  },
  MonthlyBilling: {
    customer_id: 'ID do faturamento mensal',
  },
  Email: {
    address: 'endereço de e-mail',
  },
};

export default {
  ...itensLogProposals,
  ...itensLogCustomers,
  ...itemType,
};
